import { Suspense, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import NotFoundPage from "pages/404";
import AboutUs from "pages/aboutUs";
import Account from "pages/account";
import Booking from "pages/booking";
import BookingInfo from "pages/bookingInfo";
import ChangelogPage from "pages/changelog";
import ContactUs from "pages/contact-us";
import EntryFee from "pages/entry-fee";
import FAQ from "pages/FAQ";
import FeedbackPage from "pages/feedback";
import FlightSchedules from "pages/flightSchedules";
import HomePage from "pages/home";
import PackageDealsPage from "pages/packageDeals";
import PackageDealDetailsPage from "pages/packageDeals/details";
import HotelConfirmation from "pages/hotels/confirmation";
import HotelDetails from "pages/hotels/Hotel-details";
import Hotels from "pages/hotels/Hotels";
import HotelPayment from "pages/hotels/payment";
import HotelsV2Confirm from "pages/hotelsV2/confirmation";
import HotelsV2Details from "pages/hotelsV2/details";
import HotelsV2 from "pages/hotelsV2/list";
import HotelsV2Payment from "pages/hotelsV2/payment";
import HowWeHire from "pages/how-we-hire";
import InitializeKiosk from "pages/initialize-kiosk";
import JobDetails from "pages/jobDetails";
import Jobs from "pages/jobs";
import MyTrips from "pages/myTrip";
import PrivacyPolicy from "pages/privacy-policy";
import ResetPassword from "pages/reset-password";
import Search from "pages/search";
import Visa from "pages/visa";
import { CustomRouter, customHistory } from "./custom-router";

import Dialog from "components/dialog";
import Footer from "components/footer";
import Header from "components/header";
import { useTranslation } from "i18n";
import Login from "components/login";
import SignUp from "components/signUp";
import CandidateIntake from "pages/candidateIntake";
import IamRecruitement from "pages/IamRecruitement";
import PaymentAgreementPage from "pages/paymentAgreement";
import SentooPaymentStatus from "pages/sentoo-payment-status";
import AnalyticsTracker from "analytics/AnalyticsTracker";
import { isStandaloneRoute } from "utils/standalone-routes";

// const AboutUs = lazy(() => import("pages/about-us"));
// const ContactUs = lazy(() => import("pages/contact-us"));
// const InitializeKiosk = lazy(() => import("pages/initialize-kiosk"));
// const HowWeHire = lazy(() => import("pages/how-we-hire"));
// const PrivacyPolicy = lazy(() => import("pages/privacy-policy"));
// const EntryFee = lazy(() => import("pages/entry-fee"));
// const FAQ = lazy(() => import("pages/FAQ"));
// const  = lazy(() => import("pages/account"));
// const FlightSchedules = lazy(() => import(""));
// const Jobs = lazy(() => import("pages/jobs"));

const RoutedHeader = (props) => {
  const { pathname } = useLocation();
  if (isStandaloneRoute(pathname)) return null;
  return <Header {...props} />;
};

const RoutedFooter = () => {
  const { pathname } = useLocation();
  if (isStandaloneRoute(pathname) || pathname.startsWith("/booking")) {
    return null;
  }
  return <Footer />;
};

export const AppRouter = ({ setClientSecret, setOpenCheckout }) => {
  const { t } = useTranslation();
  const [signUpModal, setSignUpModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [redirectLink, setRedirectLink] = useState();

  const handleClose = () => {
    setSignUpModal(false);

    window.location.hash = "";
  };

  const handelOpenSignUp = () => {
    setSignUpModal(true);
  };

  return (
    <CustomRouter history={customHistory}>
      <AnalyticsTracker />
      <RoutedHeader
        handelOpenSignUp={handelOpenSignUp}
        handleCloseSignUp={handleClose}
      />

      <Routes>
        <Route
          path="/"
          element={
            <Suspense fallback={<div>{t("common.loading")}</div>}>
              <HomePage setRedirectLink={setRedirectLink} />
            </Suspense>
          }
        />

        <Route
          path="/search"
          element={<Search setRedirectLink={setRedirectLink} />}
        />

        <Route path="/package-deals" element={<PackageDealsPage />} />
        <Route path="/package-deals/:id" element={<PackageDealDetailsPage />} />
        <Route path="/changelog" element={<ChangelogPage />} />

        <Route path="/forgot-password" element={<ResetPassword />} />
        <Route path="/visa/:countryName" element={<Visa />} />
        <Route path="/trips" element={<MyTrips />} />
        <Route path="/booking/:step" element={<Booking />} />
        <Route path="/jobs" element={<Jobs />} />

        <Route path="/job/:jobId" element={<JobDetails />} />

        <Route
          path="/sentoo-payment-status/:variable"
          element={<SentooPaymentStatus />}
        />

        <Route
          path="/entry-fee"
          element={
            <EntryFee
              setClientSecret={setClientSecret}
              setOpenCheckout={setOpenCheckout}
            />
          }
        />

        <Route path="/flight-schedules" element={<FlightSchedules />} />
        <Route
          path="/confirmation"
          element={
            <BookingInfo
              setClientSecret={setClientSecret}
              setOpenCheckout={setOpenCheckout}
            />
          }
        />
        <Route
          path="/my-account/:tabActive"
          element={<Account refresh={refresh} />}
        />
        <Route path="/hotels" element={<Hotels />} />
        <Route path="/hotel-details" element={<HotelDetails />} />
        <Route path="/hotel-payment" element={<HotelPayment />} />
        <Route path="/hotel-confirmation" element={<HotelConfirmation />} />

        <Route path="/hotelv2" element={<HotelsV2 />} />
        <Route path="/hotelv2-details" element={<HotelsV2Details />} />
        <Route path="/hotelv2-payment" element={<HotelsV2Payment />} />
        <Route path="/hotelv2-confirm" element={<HotelsV2Confirm />} />

        {/* candidate-intake?token=63870fa4-f46b-410b-92fa-15df7156f5cd  */}
        <Route path="/candidate-intake" element={<CandidateIntake />} />

        <Route
          path="/payment-agreement/:token"
          element={<PaymentAgreementPage />}
        />
        <Route path="/payment-agreement" element={<PaymentAgreementPage />} />

        {/* <Route path="/cars" element={<CarList />} />
        <Route path="/car-details" element={<CarDetails />} />
        <Route path="/car-payment" element={<CarPayment />} />
        <Route path="/car-confirmation" element={<CarConfirmation />} /> */}

        <Route
          path="/about-us"
          element={
            <Suspense fallback={<div>{t("common.loading")}</div>}>
              <AboutUs />
            </Suspense>
          }
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/initialize-kiosk" element={<InitializeKiosk />} />
        <Route path="/how-we-hire" element={<HowWeHire />} />
        <Route path="/FAQ" element={<FAQ />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/iam-recruitement" element={<IamRecruitement />} />
        <Route path="/*" element={<NotFoundPage />} />
      </Routes>

      <Login
        handelOpenSignUp={handelOpenSignUp}
        setRefresh={setRefresh}
        redirectLink={redirectLink}
      />

      <Dialog open={signUpModal} onClose={handleClose} padded={false}>
        <SignUp handleClose={handleClose} />
      </Dialog>

      <RoutedFooter />
    </CustomRouter>
  );
};
